import script from "./LevelWorkspacesLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelWorkspacesLoader.vue?vue&type=script&setup=true&lang=js"

import "./LevelWorkspacesLoader.vue?vue&type=style&index=0&id=4d15b932&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d15b932"]])

export default __exports__